import { PADDING_MD } from "../../../styles/constants";

export const cardStyle = {
  type: "inner",
  headStyle: {
    paddingLeft: PADDING_MD,
    paddingRight: PADDING_MD,
  },
  bodyStyle: {
    paddingLeft: PADDING_MD,
    paddingRight: PADDING_MD,
    height: 420,
  },
};

export const EL_MAPPING_ROW_HEIGHT = 400;

export const CUBE_COMPONENT_TYPE_TIME_DIMENSION = "TimeDimension";
export const CUBE_COMPONENT_TYPE_DIMENSION = "Dimension";
export const CUBE_COMPONENT_TYPE_ATTRIBUTE = "Attribute";
export const CUBE_COMPONENT_TYPE_MEASURE = "Measure";

export const EL_MAPPING_NEW_MAPPING = "EL_MAPPING_NEW_MAPPING";

export const getELMappingTranslations = t => {

  const translate = t => ({
    [EL_MAPPING_NEW_MAPPING]: t('components.easyLoading.steps.mapping.options.newMapping'),
  });

  return translate(t !== undefined ? t : str => str);
};


// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/constants.js